import React from 'react';
import PropTypes from 'prop-types';

import {
  PTBBSocialMediaSideShare,
  PTBBSocialMediaSideShareDisplay,
} from '../PTBBSocialMediaSideShare';

import styles from './index.module.scss';

const BBSocialMediaSideShareMobile = ({
  activeProviders,
  referrers,
  onPopupToggle,
  currentLocation,
  hasMobileBorders,
}) => (
  <div
    className={`${styles['bb-social-media-side-share-mobile']} ${hasMobileBorders ? styles['bb-social-media-side-share-mobile--bordered'] : ''}`}
  >
    <div className="container">
      <h6>Share your concern</h6>

      <div className={styles['bb-social-media-side-share-mobile__providers']}>
        {activeProviders.map((provider) => (
          <a
            key={provider}
            className={styles['bb-social-media-side-share-mobile__providers-link']}
            href={`${
              referrers[provider].baseURL
                ? encodeURI(referrers[provider].baseURL + currentLocation)
                : '#'
            }`}
            target={referrers[provider].target}
            aria-label={referrers[provider].alt}
            onClick={referrers[provider].baseURL ? null : onPopupToggle}
          >
            {referrers[provider].icon}
          </a>
        ))}
      </div>
    </div>
  </div>
);

BBSocialMediaSideShareMobile.propTypes = {
  ...PTBBSocialMediaSideShare,
  currentLocation: PropTypes.string.isRequired,
  referrers: PropTypes.shape(PTBBSocialMediaSideShareDisplay).isRequired,
};

export default BBSocialMediaSideShareMobile;
